import styled from "styled-components";

export const FormSection = styled("div").attrs((props: any) => ({}))`
  width: 700px;
  padding: 0px 49px 24px 48px;
`;
